import { addMonths, parse, format, getDaysInMonth, differenceInCalendarMonths } from 'date-fns';
import { PRICELINE_DATE_FORMAT } from '../../constants/dates';
import { locales, validateLocale } from '../locales';
var fallback = Date.now();
// Return an array of dates as string format yyyyMMdd
var buildDaysFns = function (month, weekStartsOn) {
  var m = format(month, 'MM');
  var y = format(month, 'yyyy');
  // Find how many days in the target month.
  var daysInMonth = Number.parseInt(getDaysInMonth(month).toString(), 10);
  // What day of the week is the first day of the month.
  var dayOne = parse("".concat(y).concat(m, "01"), PRICELINE_DATE_FORMAT, fallback);
  var padDays = Number.parseInt(format(dayOne, 'i'), 10);
  // Adjust for position of Sunday
  padDays -= Number.parseInt(weekStartsOn, 10);
  // Collapse empty weeks (eg First day of month is a Sunday)
  if (padDays === 7) padDays = 0;
  // Create an empty array and fill it with the days and the padding.
  var days = Array(padDays + daysInMonth).fill('');
  for (var i = padDays; i < days.length; i++) {
    var day = "".concat(i + 1 - padDays);
    days[i] = "".concat(y).concat(m).concat(day.padStart(2, '0'));
  }
  return days;
};
var buildMonths = function (minDate, maxDate, locale) {
  var months = [];
  var validLocale = validateLocale(locale);
  var weekStartsOn = locales[validLocale].options && locales[validLocale].options.weekStartsOn || 0;
  // Convert our start and end dates to dateObjects.
  var minUTC = parse(minDate.toString(), PRICELINE_DATE_FORMAT, fallback);
  var maxUTC = parse(maxDate.toString(), PRICELINE_DATE_FORMAT, fallback);
  // Determine our loop start and end.
  var monthsToBuild = differenceInCalendarMonths(maxUTC, minUTC);
  for (var i = 0; i <= monthsToBuild; i++) {
    var currentMonth = addMonths(minUTC, i);
    var monthIndex = Number.parseInt(format(currentMonth, 'M'), 10) - 1;
    // Build the month.
    var days = buildDaysFns(currentMonth, weekStartsOn);
    // Build the labels.
    var labels = days.map(function (date) {
      return date ? format(parse(date, PRICELINE_DATE_FORMAT, Date.now()), 'MMMM d, yyyy') : '';
    });
    months.push({
      monthIndex: monthIndex,
      month: "".concat(format(currentMonth, 'MM')),
      year: "".concat(format(currentMonth, 'yyyy')),
      days: days,
      labels: labels
    });
  }
  return months;
};
export default buildMonths;